type SupplyPointsAddress = {
  addressLines?: ReadonlyArray<string> | null;
  postCode?: string | null;
};

export const formatPostalAddress = (postalAddress?: SupplyPointsAddress) => {
  if (!postalAddress?.addressLines && !postalAddress?.postCode) {
    return '';
  }

  const addressLines = postalAddress?.addressLines
    ? postalAddress?.addressLines.join(', ')
    : '';
  const postcode = postalAddress?.postCode ? postalAddress.postCode : '';
  const postcodeSeparator =
    postalAddress?.addressLines && postalAddress?.postCode ? ', ' : '';

  return addressLines + postcodeSeparator + postcode;
};
